export default __webpack_public_path__ + "4c79c85c284a1086a21e7df09cf90b2a.png";